/*
 * Copyright (C) 2019 SADE Innovations Oy - All Rights Reserved
 *
 * NOTICE: This software is owned by SADE Innovations Oy and licensed under SADE Booster license.
 * All dissemination, usage, modification, copying, reproduction, selling and distribution of the
 * software and its intellectual and technical concepts are strictly forbidden without a valid license.
 * Such license can be obtained by issuing a SADE Booster License agreement from SADE Innovations Oy
 * (https://sadeinnovations.com).
 *
 */

import { Box, Button, Dialog, DialogProps, Grid, Typography } from "@material-ui/core";
import React, { Component, ReactNode } from "react";
import { translations } from "../../generated/translationHelper";

interface Props {
  isOpen: boolean;
  onAccept: () => void;
  onCancel: () => void;
  title?: string;
  disableAccept?: false | boolean;
  acceptButtonText?: string;
  cancelButtonText?: string;
  maxWidth?: DialogProps["maxWidth"];
  children?: ReactNode;
}

/**
 * Simple "form" style dialog, where
 * <FormDialog>
 *   <ChildComponent1 />
 *   <ChildComponent2 />
 * </FormDialog>
 *
 * are placed within a <List>
 */
export default class FormDialog extends Component<Props> {
  public constructor(props: Props) {
    super(props);
  }

  public render(): JSX.Element {
    const ACCEPT_TEXT = translations.common.buttons.accept();
    const CANCEL_TEXT = translations.common.buttons.cancel();

    const renderChildren = (): ReactNode => {
      const children: ReactNode[] =
        this.props.children == null
          ? []
          : Array.isArray(this.props.children)
          ? this.props.children
          : [this.props.children];
      return children.map((child, i) => {
        return (
          <Grid key={i} item={true} container={true} xs={12} justifyContent="center">
            {child}
          </Grid>
        );
      });
    };

    return (
      <Dialog onClose={this.props.onCancel} open={this.props.isOpen} maxWidth={this.props.maxWidth}>
        <Box padding={3} style={{ overflow: "hidden" }}>
          <Grid container={true} direction={"column"} spacing={3}>
            {this.props.title && (
              <Grid item={true} container={true} xs={12} justifyContent="center">
                <Typography variant="h6">{this.props.title}</Typography>
              </Grid>
            )}

            {renderChildren()}

            <Grid item={true} container={true} justifyContent="center" spacing={6}>
              <Grid item={true}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.props.onAccept}
                  disabled={this.props.disableAccept ?? false}
                >
                  {this.props.acceptButtonText ?? ACCEPT_TEXT}
                </Button>
              </Grid>
              <Grid item={true}>
                <Button variant="contained" color="primary" onClick={this.props.onCancel}>
                  {this.props.cancelButtonText ?? CANCEL_TEXT}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    );
  }
}
